import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import {
  SpuTopUpQuery,
  SpuTopUpVo,
  SpuBusinessOtherQuery,
  SpuBusinessOtherVo,
  DeliveryParamCheckDTO,
  VerifyTopUpDeliveryParamResult
} from './type';

/**
 * spu展示页面
  top up业务sku卡片列表 查询
  GET /product/urlMapping/game-service/getTopUpSpuInfoShowVo
  接口ID：257336683
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-257336683
 */
export const getSpuTopUp = (params: SpuTopUpQuery): AxiosPromise<SpuTopUpVo> => {
  return request({
    url: '/product/urlMapping/game-service/getTopUpSpuInfoShowVo',
    method: 'get',
    params
  });
};

/**
 * 根据业务查询游戏
  GET /product/urlMapping/game-service/getEntityByBusinessId
  接口ID：257336688
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-257336688
 */
export const getBusinessOther = (params: SpuBusinessOtherQuery): AxiosPromise<SpuBusinessOtherVo> => {
  return request({
    url: '/product/urlMapping/game-service/getEntityByBusinessId',
    method: 'get',
    params
  });
};

// 校验top up的发货参数
// POST /product/urlMapping/game-service/deliveryParamsVerify
// 接口ID：389590825
// 接口地址：https://app.apifox.com/link/project/4822917/apis/api-389590825
export const spuTopUpDeliveryCheck = (data: DeliveryParamCheckDTO): AxiosPromise<VerifyTopUpDeliveryParamResult> => {
  return request({
    url: '/product/urlMapping/game-service/deliveryParamsVerify',
    method: 'post',
    data
  });
};
